import loadable from '@loadable/component';

// 懒加载组件
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));
const CstStatementConfirmationInfoQuery = loadable(() => import('./cstStatementConfirmationInfoQuery/CstStatementConfirmationInfoQuery'));

export const subRoutes = [
  { // 供应商发票管理 (中部战区定制化)
    path: '/InvoiceManagement',
    component: InvoiceManagement
  },
  { // 销售结算确认数据查询 (中部战区定制化)
    path: '/CstStatementConfirmationInfoQuery',
    component: CstStatementConfirmationInfoQuery
  }
];
